// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"ResetPasswordPage_contentContainer__3zmQ1","formContainer":"ResetPasswordPage_formContainer__1r4wD","language":"ResetPasswordPage_language__3N9Nn"};